import React from "react";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {GridCell, GridContainer} from "../../../../Components/Grid";
import {Allow, policyEvents} from "../../../../Components/Authorize";
import {getLoanLibraryMediaFormatTextByValue} from "../loanLibraryConstants";
import {getAvailabilityStatus, renderCatalogDetail} from "../loanLibraryCatalogUtilities";

interface LoanLibraryCatalogItemProps {
    author?: string;
    description?: string;
    handleClickEdit?: () => void;
    loanLibraryCatalogId?: string;
    mediaFormat?: number;
    productName?: string;
    quantityCurrentlyAvailable?: number;
    totalQuantity?: number;
    [key: string]: unknown;
}

export const LoanLibraryCatalogItem = ({
                                           author,
                                           description,
                                           handleClickEdit,
                                           loanLibraryCatalogId,
                                           mediaFormat,
                                           productName,
                                           quantityCurrentlyAvailable,
                                           totalQuantity,
                                       }: LoanLibraryCatalogItemProps) => {

    const availabilityStatus = getAvailabilityStatus(quantityCurrentlyAvailable ?? 0, totalQuantity ?? 0);

    return (
        <GridContainer className={`catalog__item`} hasMarginX>
            <GridCell>
                {
                    handleClickEdit &&
                    <Allow policyEvent={policyEvents.MANAGE_LOAN_LIBRARY_CATALOG}>
                        <div className={`align-right margin--topNegative`}>
                            <ButtonLinkStyle
                                label={`Edit Item`}
                                name={`btnEdit${loanLibraryCatalogId}`}
                                onClick={handleClickEdit}
                            />
                        </div>
                    </Allow>
                }
                <h3 id={`title${loanLibraryCatalogId}`} className={`margin--bottomNone`}>
                    {productName}
                </h3>
                {renderCatalogDetail(author, "Author")}
                {renderCatalogDetail(getLoanLibraryMediaFormatTextByValue(mediaFormat), "Media Format")}
                {renderCatalogDetail(description, "Description")}
                <div style={{marginTop: '10px'}}>{availabilityStatus}</div>
            </GridCell>
        </GridContainer>
    );
};
